"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

var PopoverBody = (0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    backgroundColor: theme.selectors.color('neutral0'),
    borderRadius: theme.selectors.radius(_constants.POPOVER_BODY_RADIUS),
    border: "1px solid ".concat(theme.selectors.color('neutral20')),
    boxShadow: "0 0 10px 0 ".concat((0, _utils.opacify)(theme.selectors.color('neutral90'), 0.2)),
    // Focus on the popover body is not visible because we treat it like
    // a modal context (where "nothing" is focused when it opens). Since
    // the body has tabIndex -1, it can only ever be focused on open, so
    // the user cannot lose track of where focus is once they tab away
    // from the popover body.
    outline: 'none'
  };
});
PopoverBody.displayName = 'PopoverBody';
var _default = PopoverBody;
exports.default = _default;